import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UncontrolledCollapse } from "reactstrap";
import { FaMinus, FaLockOpen } from "react-icons/fa";
import ConstData from "../../../lib/ConstData";
import Alerts from "../../etc/list/Alerts";
// 20260828 로컬 사이트 이름 인라인 수정용 공용 컴포넌트
import InlineEditCell from "../common/InlineEditCell";

const WebLocalSiteInfo = ({ idx, localSite_info, handleSelectedFunc }) => {
    const { t } = useTranslation();

    // 20260828 이름 인라인 수정 결과를 로컬 서버 관리 화면의 상세설정 저장과 동일하게 해당 행에서만 표시한다 (2.5초 후 자동 숨김)
    const [nameAlert, setNameAlert] = useState({ kind: ConstData.ALERT_KIND.NONE, message: "" });

    useEffect(() => {
        if (!localSite_info.nameAlertEventId) return;
        setNameAlert({ kind: localSite_info.nameAlertKind, message: localSite_info.nameAlertMessage });
        const timer = setTimeout(() => setNameAlert({ kind: ConstData.ALERT_KIND.NONE, message: "" }), 2500);
        return () => clearTimeout(timer);
    }, [localSite_info.nameAlertEventId]);

    const onHandleRemoveSite = () => {
        handleSelectedFunc({ selectedFunc: "DELETE_LOCAL_SITE", data: localSite_info.localSiteSeq });
    }

    // 20260828 로컬 사이트 이름 인라인 수정 - 연필 아이콘 확인 클릭 시 즉시 저장
    const onHandleChangeSiteName = (newName) => {
        handleSelectedFunc({ selectedFunc: "CHANGE_LOCAL_SITE_NAME", data: { localSiteSeq: localSite_info.localSiteSeq, localSiteName: newName } });
    }

    const onChangeOpenOption = (localSiteSeq, flag) => {
        if (flag) {
            handleSelectedFunc({ selectedFunc: "SET_LOCAL_SITE_OPEN", data: { localSiteSeq: localSite_info.localSiteSeq, openLocalSiteSeq: localSiteSeq } });

            // 해당 site 공유 허용 : openable list => open list
        } else {
            handleSelectedFunc({ selectedFunc: "SET_LOCAL_SITE_CLOSE", data: { localSiteSeq: localSite_info.localSiteSeq, openLocalSiteSeq: localSiteSeq } });
            // 해당 site 공유 중지 : open list => openable list
        }
    }

    return (
        <>
            {/* teacher/class 탭과 동일한 list-table 행 스타일 (하위 목록보기 서브테이블은 기존 그대로 유지) */}
            <tr>
                <td className="text-center">
                    <span className="info content hiclass-text">{localSite_info.localSiteSeq}</span>
                </td>
                {/* 260804 사이트 이름이 길 때 잘리지 않던 문제 수정 - admin-ellipsis-cell/text로 말줄임(...) 처리 */}
                {/* 20260828 사이트 이름 옆 연필 아이콘 클릭 시 인라인 입력으로 전환, 확인 클릭 시 즉시 저장 */}
                <td className="text-center">
                    <div className="d-flex align-items-center justify-content-center admin-ellipsis-cell">
                        <InlineEditCell
                            value={localSite_info.localSiteName}
                            textClassName="info title hiclass-text admin-ellipsis-text"
                            requiredMessage={t("로컬_사이트_이름_입력", { ns: "admin" })}
                            onSave={onHandleChangeSiteName}
                        />
                    </div>
                </td>
                <td className="text-center">
                    <button className="btn-table-action" type="button" id={"openSiteList_" + idx}>
                        {t("목록보기", { ns: "admin" })}
                    </button>
                </td>
                <td className="text-center">
                    <button type="button" className="btn-table-action btn-danger" title={t("로컬_사이트_삭제", { ns: "admin" })} onClick={() => onHandleRemoveSite()}>
                        {t("삭제", { ns: "common" })}
                    </button>
                </td>
            </tr>
            {/* 20260828 이름 인라인 수정 결과 - 해당 행 바로 아래에서만 표시하고 2.5초 후 사라진다 */}
            {nameAlert.kind !== ConstData.ALERT_KIND.NONE &&
                <tr className="b-none local-site-detail-row">
                    <td colSpan={4} className="p-0">
                        <div className="d-flex align-items-center justify-content-center w-100">
                            <div className="area-90 mt-1">
                                <Alerts kind={nameAlert.kind} message={nameAlert.message} />
                            </div>
                        </div>
                    </td>
                </tr>
            }
            {/* 260724 오픈 사이트 상세 행을 전체 4개 열 너비로 확장하고 중복 구분선 제거 */}
            <tr className="b-none local-site-detail-row">
                <td colSpan={4} className="p-0">
                    <UncontrolledCollapse toggler={"#openSiteList_" + idx} className="w-100" defaultOpen={false}>
                        <table className="d-flex flex-column table-sm sub-list table-hover mb-0" style={{ background: 'rgb(235, 235, 235)' }}>
                            <thead>
                                <tr className="d-flex">
                                    {/* 20260828 다국어 키 통일: Seq. -> 순번 */}
                                    <th className="d-flex align-items-center justify-content-center area-10">
                                        <b>{t("순번", { ns: "admin" })}</b>
                                    </th>
                                    <th className="d-flex align-items-center justify-content-center area-70">
                                        <b>{t("사이트_이름", { ns: "admin" })}</b>
                                    </th>
                                    <th className="area-10" />
                                    <th className="area-10" />
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    localSite_info.list_openLocalSite && localSite_info.list_openableLocalSite && (localSite_info.list_openLocalSite.length > 0 || localSite_info.list_openableLocalSite.length > 0) ?
                                        <>
                                            {
                                                localSite_info.list_openLocalSite.map(site => (
                                                    <tr key={"openSite-" + site.localSiteSeq} className="d-flex">
                                                        <td className="d-flex align-items-center justify-content-center area-10">
                                                            {/* <span className="font-weight-bold">{site.localSiteSeq}</span> */}
                                                            <span className="info content hiclass-text" style={{ fontWeight: 'bold' }}>{site.localSiteSeq}</span>
                                                        </td>
                                                        <td className="d-flex align-items-center justify-content-center area-70">
                                                            <FaLockOpen className="font-sm mr-2 green-text" style={{ verticalAlign: 'text-top', flexShrink: 0 }} />
                                                            {/* <span className="font-weight-bold">{site.localSiteName}</span> */}
                                                            {/* 260804 사이트 이름 말줄임(...) 처리 - 이 td는 원래부터 d-flex 가짜 테이블이라 span에 바로 적용 */}
                                                            <span className="info title hiclass-text admin-ellipsis-text" title={site.localSiteName} style={{ minWidth: 0, flex: '1 1 auto' }}>{site.localSiteName}</span>
                                                        </td>
                                                        <td className="d-flex align-items-center justify-content-center area-10 p-0">
                                                            <button type="button" className="btn btn-sm red white-text py-1 px-2 " title={t("공유_닫기", { ns: "admin" })} onClick={() => onChangeOpenOption(site.localSiteSeq, false)}>
                                                                <b>{t("close", { ns: "admin" })}</b>
                                                            </button>
                                                        </td>
                                                        <td className="area-10" />
                                                    </tr>
                                                ))
                                            }
                                            {
                                                localSite_info.list_openableLocalSite.map(site => (
                                                    <tr key={"openableSite-" + site.localSiteSeq} className="d-flex">
                                                        <td className="d-flex align-items-center justify-content-center area-10">
                                                            {/* <span className="font-weight-bold">{site.localSiteSeq}</span> */}
                                                            <span className="info content hiclass-text">{site.localSiteSeq}</span>
                                                        </td>
                                                        <td className="d-flex align-items-center justify-content-center area-70">
                                                            {/* <span className="font-weight-bold">{site.localSiteName}</span> */}
                                                            {/* 260804 사이트 이름 말줄임(...) 처리 - 이 td는 원래부터 d-flex 가짜 테이블이라 span에 바로 적용 */}
                                                            <span className="info title hiclass-text admin-ellipsis-text" title={site.localSiteName} style={{ minWidth: 0, flex: '1 1 auto' }}>{site.localSiteName}</span>
                                                        </td>
                                                        <td className="d-flex align-items-center justify-content-center area-10 p-0">
                                                            <button type="button" className="btn btn-sm green white-text py-1 px-2 " title={t("공유_열기", { ns: "admin" })} onClick={() => onChangeOpenOption(site.localSiteSeq, true)}>
                                                                <b>{t("open", { ns: "admin" })}</b>
                                                            </button>
                                                        </td>
                                                        <td className="area-10" />
                                                    </tr>
                                                ))
                                            }
                                        </> :
                                        <tr className="d-flex w-100">
                                            <td className="d-flex w-100 p-0">
                                                <div className="d-flex w-100 view m-3 justify-content-center grey-text" style={{ fontSize: '0.9rem' }}>
                                                    {t("로컬_사이트_목록_없음", { ns: "admin" })}
                                                </div>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </UncontrolledCollapse>
                </td>
            </tr>
        </>
    );
}

export default WebLocalSiteInfo;
